import { render, staticRenderFns } from "./FragmentIngredients.vue?vue&type=template&id=f1f52758"
import script from "./FragmentIngredients.vue?vue&type=script&lang=ts"
export * from "./FragmentIngredients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports